import { message } from 'ant-design-vue';
import { urlResquest } from '../../../../services/urlConfig';
// import businessService from '@/services/business'
// import { getAllArticleAndTextFileList } from '../../../home/methods';

export default function getList(callback) {
  // 筛选无字幕文件
  function checkAudioNoIrc(data) {
    return data;
  }
  // 获取全部内容
  const getAllList = (
    params = { sortKey: 'alphabeticIncrease', columnKey: 'defaultColumnKey' }
  ) => {
    // console.log(params);
    const hideLoading = message.loading({ content: 'loading', duration: 0 });
    urlResquest.getArticleAndFileList(params).then(res => {
      hideLoading();
      if (res.code === 0) {
        checkAudioNoIrc(res.data);
        callback(res.data);
      } else {
        message.error({ content: '网络失败，请重试' });
      }
    });
  };

  // // 获取文件夹详情
  // const getFolderDetailList = (params = { sortKey: 'alphabeticIncrease', columnKey: 'defaultColumnKey' }) => {
  //   const hideLoading = message.loading({ content: 'loading', duration: 0 })
  //   businessService.getArticleAndTextFileList(params).then((res) => {
  //     hideLoading()
  //     if (res.code === 0) {
  //       callback(res.data)
  //     } else {
  //       message.error({ content: res.msg })
  //     }
  //   }).catch((e) => {
  //     message.error({ content: e })
  //   })
  // }
  return {
    getAllList,
    // getFolderDetailList,
  };
}
